/*
 * Copyright (C) 2018 Bruno López Trigo
 * 
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; either version 2
 * of the License, or (at your option) any later version.

 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.

 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 */

import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import AddBox from "@material-ui/icons/AddBox";
import {CardHeader} from "@material-ui/core";
import CardMedia from "@material-ui/core/CardMedia";
import Typography from "@material-ui/core/Typography";
import Popup from "reactjs-popup";
import UploadFile from "../images/uploadFile.jpg";

const styles = {
  card: {
    minWidth: 200,
    width: "30%",
    margin: 20,
    maxWidth: 400,
    backgroundColor:"#e7e7e7",
  },
  media: {
    height: 140
  },
  buttonInfo: {
    fontSize: "16px",
    color: "#687aff",
    width: "50%"
  },
  buttonSelect: {
    fontSize: "16px",
    color: "#4caf50",
    width: "100%"
  },
  content: {
    textAlign: "center"
  },
  link: {
    width:"50%",
    textDecoration: "none"
  }
};

function DatasetCard(props) {
  const { classes } = props;

  return (
    <Card className={classes.card}>
      <CardContent className={classes.content}>
        <Link className={classes.link} to="/builder">
          <AddBox
            style={{ fontSize: 190, fill: "#4caf50", cursor: "pointer" }}
          />
        </Link>
      </CardContent>
      <CardActions style={{marginTop:-30}}>
        <Link className={classes.link} to="/builder">
          <Button size="small" color="primary" className={classes.buttonSelect}>
            {props.language.labels[props.language.id].select}
          </Button>
        </Link>
        <Popup trigger={
          <Button
              size="small"
              className={classes.buttonInfo}
          >
            {props.language.labels[props.language.id].info}
          </Button>} modal >
          <Card >
            <CardHeader title={"Upload a new Dataset"} />
            <CardMedia
                className={classes.media}
                image={UploadFile}
            />
            <CardContent>
              <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                You have to upload a dataset in arff format and select the algorithms for which you want to build classifiers. For each algorithm, you can keep or edit the given default parameters.
              </Typography>
            </CardContent>
          </Card>
        </Popup>
      </CardActions>
    </Card>
  );
}

DatasetCard.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(DatasetCard);
